// src/pages/components/AuthLanguageSelector.jsx - Apartment Management System
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RiGlobalLine, RiArrowDownSLine } from 'react-icons/ri';
import { useTheme } from '../../contexts/ThemeContext';

const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'ar', label: 'العربية' },
  { code: 'ku', label: 'کوردی' },
  { code: 'de', label: 'Deutsch' },
  { code: 'fr', label: 'Français' },
  { code: 'it', label: 'Italiano' },
  { code: 'sp', label: 'Español' }
];

const RTL_LANGS = ['ar', 'ku'];

const AuthLanguageSelector = () => {
  const { i18n } = useTranslation();
  const { isDarkMode, isRTL, toggleRTL } = useTheme();
  const [open, setOpen] = useState(false);

  const currentLabel = LANGUAGES.find((l) => l.code === i18n.language)?.label || 'English';

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setOpen(false);

    if (RTL_LANGS.includes(lng) && !isRTL) {
      toggleRTL();
    } else if (!RTL_LANGS.includes(lng) && isRTL) {
      toggleRTL();
    }
  };

  return (
    <div className="absolute top-4 end-4 z-20">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className={`flex items-center gap-1 px-3 py-1.5 rounded-lg border text-sm font-medium transition-colors ${
        isDarkMode ?
        'bg-zinc-900 border-white/[0.1] text-zinc-300 hover:bg-zinc-800' :
        'bg-white border-black/[0.1] text-zinc-700 hover:bg-zinc-50'}`
        }
        aria-label="Select language">

        <RiGlobalLine size={16} />
        <span className="hidden sm:inline">{currentLabel}</span>
        <RiArrowDownSLine size={14} />
      </button>

      {open &&
      <>
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />
          <div className={`absolute end-0 mt-2 w-40 rounded-lg shadow-lg border z-20 ${
          isDarkMode ? 'bg-zinc-900 border-white/[0.1]' : 'bg-white border-black/[0.1]'}`
          }>
            <div className="py-1">
              {LANGUAGES.map(({ code, label }) =>
            <button
              key={code}
              type="button"
              onClick={() => changeLanguage(code)}
              className={`flex items-center w-full px-4 py-2 text-sm transition-colors ${
              i18n.language === code ?
              isDarkMode ? 'bg-red-900/20 text-red-400' : 'bg-zinc-50 text-red-600' :
              isDarkMode ? 'text-gray-300 hover:bg-zinc-800' : 'text-gray-700 hover:bg-gray-100'}`
              }>

                  {label}
                </button>
            )}
            </div>
          </div>
        </>
      }
    </div>);

};

export default AuthLanguageSelector;
